import type { ReactNode } from 'react';
import { cloneElement } from 'react';

interface ProviderComposerProps {
  contexts: React.ReactElement[];
  children: ReactNode;
}

export const ProviderComposer = ({
  contexts,
  children,
}: ProviderComposerProps) =>
  contexts.reduceRight(
    (kids: ReactNode, parent: React.ReactElement) =>
      cloneElement(parent, {
        children: kids,
      }),
    children
  );
